
const androidIntroduceRoute = {
  path: '/android-introduce',
  name: 'androidIntroduce',
  component: () => import('@/views/introduce/android-introduce'),
  meta: {hidden: true}
}
export default androidIntroduceRoute



// WEBPACK FOOTER //
// ./src/router/modules/androidIntroduce.js